import { useSelector, useDispatch } from "react-redux";

const useColorMode = () => {
  const mode = useSelector((state) => state.config.mode);
  const dispatch = useDispatch();

  return {
    mode,
    toggle: () => dispatch.config.toggleMode(),
  };
};

export default useColorMode;
